import { Routes } from '@angular/router';
import { FormComponent } from './pages/form/form/form.component';
import { CaseComponent } from './pages/case/case/case.component';

export const routes: Routes = [
  { path: '', component: FormComponent },
  { path: 'case/:id', component: CaseComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
